import { z } from 'zod';

export const calendarEventAttendeeFormSchema = z.object({
  id: z.number(),
  emailAddress: z.object({
    name: z.string(), // FirstName (if exists) and LastName of legalClient
    address: z.string(), // Email of legalClient
  }),
});

export type ICalendarEventAttendeeForm = z.infer<
  typeof calendarEventAttendeeFormSchema
>;
